import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/screen/feed/view/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/screen/feed/view/seo/styles.module.scss");
